import { useContext } from "react";
import { Col, Form, Row } from "react-bootstrap";

import { DataFormFieldContext } from "../../contexts/dataFormFieldContext";
import { FormFieldTitle } from "./formFieldTitle";

export const FormControlWrapper = ({
	children,
	error,
	"data-testid": testId,
}: {
	children: any;
	error?: any;
	"data-testid"?: string;
}) => {
	const { isVerticalLayout, hasFieldTitle = true } =
		useContext(DataFormFieldContext);

	if (isVerticalLayout)
		return (
			<Form.Group className="mb-2" data-testid={testId}>
				{hasFieldTitle ? <FormFieldTitle /> : null}
				{children}
				<div className="text-danger">
					<small>{error}</small>
				</div>
			</Form.Group>
		);

	return (
		<Form.Group className="mb-2" as={Row} data-testid={testId}>
			{hasFieldTitle ? <FormFieldTitle /> : null}
			<Col sm={9}>
				{children}
				<div className="text-danger">
					<small>{error}</small>
				</div>
			</Col>
		</Form.Group>
	);
};
